import styles from './template.css';
import template from './template';
import {storeInstance} from '@aofl/store/dist/legacy';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

import translations from '@modules/i18n';
import {sdoNs} from '@modules/constants-enumerate';

/**
 * @summary RoleView
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('role-view')
class RoleView extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of RoleView.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'role-view';

  @property({type: Object})
  role = null;

  @property({type: Object})
  modalData = {};

  @property({type: Number})
  ['user-id'] = 0;

  @property({type: Boolean})
  isRootAdmin = false;

  @property({type: Number, mapState: `${sdoNs.SESSION}.id`, store: storeInstance})
  loggedInUserId;

  @property({type: Object, mapState: `${sdoNs.SESSION}.settings`, store: storeInstance})
  settings;

  connectedCallback() {
    super.connectedCallback();
  }

  discard() {
    storeInstance.commit({
      namespace: sdoNs.ADMIN_UINFO,
      mutationId: 'removeRole',
      payload: this.role.id
    });
    this.dispatchEvent(new CustomEvent('on-dismiss'));
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default RoleView;
